import React, { useState } from "react";
import "./index.scss";
import { enviarEmailCompleto } from "../../utils/enviarEmail";

export const INPUT = ({
  style,
  value,
  onChange,
  transparente,
  obrigatorio,
  placeholder,
}) => {
  return (
    <input
      style={style}
      value={value}
      onChange={(e) => onChange(e)}
      required={obrigatorio ? true : false}
      placeholder={placeholder ? placeholder : "Digite..."}
      className={transparente ? "input-transparente" : "input-branco"}
    />
  );
};

export const TEXTAREA = ({
  style,
  value,
  onChange,
  transparente,
  obrigatorio,
  placeholder,
}) => {
  return (
    <textarea
      style={style}
      value={value}
      onChange={(e) => onChange(e)}
      required={obrigatorio ? true : false}
      placeholder={placeholder ? placeholder : "Digite..."}
      className={transparente ? "input-transparente" : "input-branco"}
    />
  );
};

export const BUTTON = ({ placeholder, type, onClick }) => {
  return (
    <button type={type} className="button" onClick={onClick}>
      {placeholder ? placeholder : "Enviar"}
    </button>
  );
};

export const Formulario = ({
  formularioTransparente,
  nomeCampo,
  emailCampo,
  telefoneCampo,
  mensagemCampo,
  empresaCampo,
  flexLinha,
  apiEnvio,
  textoBotao
}) => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [telefone, setTelefone] = useState("");
  const [mensagem, setMensagem] = useState("");

  const enviarFormuario = () => {
    const form = {
      dsc_nome: nome,
      dsc_empresa: empresa,
      dsc_email: email,
      num_telefone: telefone,
      dsc_mensagem: mensagem,
    };
    enviarEmailCompleto(form)
  };

  return (
    <form
      style={flexLinha && { flexDirection: "row" }}
      onSubmit={(event) => {
        event.preventDefault();
        enviarFormuario();
      }}
    >
      {nomeCampo && (
        <INPUT
          placeholder="Nome"
          transparente={formularioTransparente}
          onChange={(e) => setNome(e.target.value)}
          value={nome}
          obrigatorio
        />
      )}
      {emailCampo && (
        <INPUT
          placeholder="E-mail"
          transparente={formularioTransparente}
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          obrigatorio
        />
      )}
      {telefoneCampo && (
        <INPUT
          placeholder="Telefone"
          transparente={formularioTransparente}
          onChange={(e) => setTelefone(e.target.value)}
          value={telefone}
          obrigatorio
        />
      )}
      {empresaCampo && (
        <INPUT
          placeholder="Empresa"
          transparente={formularioTransparente}
          onChange={(e) => setEmpresa(e.target.value)}
          value={empresa}
          obrigatorio
        />
      )}
      {mensagemCampo && (
        <TEXTAREA
          placeholder="Mensagem"
          transparente={formularioTransparente}
          onChange={(e) => setMensagem(e.target.value)}
          value={mensagem}
          obrigatorio
        />
      )}
      <div className="div-botao">
        <BUTTON type="submit" placeholder={textoBotao}/>
      </div>
    </form>
  );
};
